<template>
    <v-container fluid>
        <v-row style="padding-bottom: 20px;">
            <v-col
                style="display: flex; align-content: center; align-items: center;"
                cols="12"
                xl="4"
                lg="4"
                md="5"
                sm="12"
            >
                <h3>Coverage Request Report</h3>
            </v-col>
        </v-row>

        <v-row>
            <v-col
                cols="12"
                lg="3"
                md="6"
                sm="12"
            >
                <v-menu
                    ref="mnuStartDate"
                    v-model="mnuStartDate"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="300px"
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <label>Start Date</label>
                        <v-text-field
                            v-model="filter.startDateFormatted"
                            prepend-inner-icon="mdi-calendar"
                            v-mask="'##/##/####'"
                            v-bind="attrs"
                            outlined
                            single-line
                            v-on="on"
                            dense
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="filter.startDate"
                        no-title
                        @input="mnuStartDate = false"
                        color="primary lighten-1"
                    ></v-date-picker>
                </v-menu>
            </v-col>

            <v-col
                cols="12"
                lg="3"
                md="6"
                sm="12"
            >
                <v-menu
                    ref="mnuEndDate"
                    v-model="mnuEndDate"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="300px"
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <label>End Date</label>
                        <v-text-field
                            v-model="filter.endDateFormatted"
                            prepend-inner-icon="mdi-calendar"
                            v-mask="'##/##/####'"
                            v-bind="attrs"
                            outlined
                            single-line
                            v-on="on"
                            dense
                        ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="filter.endDate"
                        no-title
                        @input="mnuEndDate = false"
                        color="primary lighten-1"
                    ></v-date-picker>
                </v-menu>
            </v-col>

            <v-col
                cols="12"
                lg="2"
                md="4"
                sm="12"
            >
                <label>Requested By</label>
                <v-combobox
                    v-model="filter.requesterSelected"
                    :items="listSellers"
                    item-text="name"
                    item-value="id"
                    clearable
                    outlined
                    dense
                    @change="getRegisters()"
                ></v-combobox>
            </v-col>

            <v-col
                cols="12"
                lg="2"
                md="4"
                sm="12"
            >
                <label>Requested To</label>
                <v-combobox
                    v-model="filter.requestedSelected"
                    :items="listSellers"
                    item-text="name"
                    item-value="id"
                    clearable
                    outlined
                    dense
                    @change="getRegisters()"
                ></v-combobox>
            </v-col>

            <v-col
                cols="12"
                lg="1"
                md="3"
                sm="10"
            >
                <label>Status</label>
                <v-combobox
                    v-model="filter.decisionStatusSelected"
                    :items="listDecisionStatus"
                    item-text="description"
                    item-value="id"
                    clearable
                    outlined
                    dense
                    @change="getRegisters()"
                ></v-combobox>
            </v-col>

            <v-col
                style="text-align: right; margin-top: 22px;"
                cols="12"
                lg="1"
                md="1"
                sm="2"
            >
                <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            v-bind="attrs"
                            v-on="on"
                            @click="getRegisters"
                        >
                            Refresh
                        </v-btn>
                    </template>
                    <span>Refresh</span>
                </v-tooltip>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-tabs
                    v-model="tabReport"
                    fixed-tabs
                >
                    <v-tab key="1" @click="getRegisters">
                        Bar Chart
                    </v-tab>
                    <v-tab key="2" @click="getRegisters">
                        Analytical
                    </v-tab>
                </v-tabs>

                <v-tabs-items v-model="tabReport">
                    <v-tab-item key="1">
                        <br />
                        <v-row>
                            <v-col
                                cols="12"
                                lg="12"
                                md="12"
                                sm="12"
                            >
                                <BarChart
                                    ref="chartCoverageRequests"
                                    :chartId="'coverageRequestsBySalesPerson'"
                                    :chartData="dashboardCoverageRequestBySalesPerson"
                                />
                            </v-col>

                            <v-col
                                v-if="requesterByRequestedSummary.length > 0"
                                cols="12"
                                lg="12"
                                md="12"
                                sm="12"
                            >
                                <div style="font-size: 14px; font-weight: 600; color: #14435B; margin-bottom: 8px;">
                                    Requested By (per Requested To)
                                </div>

                                <v-row>
                                    <v-col
                                        v-for="(item, index) in requesterByRequestedSummary"
                                        :key="`requester-summary-${index}`"
                                        cols="12"
                                        lg="6"
                                        md="6"
                                        sm="12"
                                    >
                                        <div style="font-size: 13px;">
                                            <strong>{{ item.requestedToName }}:</strong> {{ item.requesterNames }}
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-tab-item>

                    <v-tab-item key="2">
                        <br />

                        <v-col
                            style="text-align: right;"
                            cols="12"
                        >
                            <v-tooltip left>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="exportFile(URL_REPORT_COVERAGE_REQUEST_ANALYTICAL, getFilterRequest());"
                                    >
                                        Export PDF
                                    </v-btn>
                                </template>
                                <span>Export Report to PDF</span>
                            </v-tooltip>
                        </v-col>

                        <v-col cols="12">
                            <v-data-table
                                :headers="headers"
                                :items="listCoverageRequestAnalytical"
                                :options.sync="options"
                                :loading="loading"
                                :items-per-page="10"
                                no-data-text="No Record Found"
                            >
                                <template v-slot:item.jobIdFormatted="{ item }">
                                    <v-tooltip left>
                                        <template v-slot:activator="{ on }">
                                            <a @click="goToServiceDetails(item.idService)" v-on="on" target="_blank">
                                                {{ item.jobIdFormatted }}
                                            </a>
                                        </template>
                                        <span>Job Details</span>
                                    </v-tooltip>
                                </template>

                                <template v-slot:item.requestReason="{ item }">
                                    <span>{{ item.requestReason || '-' }}</span>
                                </template>

                                <template v-slot:item.decisionReason="{ item }">
                                    <span>{{ item.decisionReason || '-' }}</span>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-tab-item>
                </v-tabs-items>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import Helpers from '@/utilities/Helpers';
import BarChart from '@/components/Graphics/Bar.vue';
import * as moment from 'moment';
import {
    URL_REPORT_COVERAGE_REQUEST_ANALYTICAL
} from '@/utilities/Enums';

export default ({

    mixins: [Helpers],

    components: {
        BarChart
    },

    data: () => ({
        loading: false,

        tabReport: null,

        listSellers: [],
        listDecisionStatus: [
            { id: 0, description: 'Pending' },
            { id: 1, description: 'Accepted' },
            { id: 2, description: 'Denied' },
        ],

        filter: {
            requesterSelected: null,
            requestedSelected: null,
            decisionStatusSelected: null,
            startDate: moment().clone().startOf('month').format('YYYY-MM-DD'),
            endDate: moment().clone().endOf('month').format('YYYY-MM-DD'),
            startDateFormatted: moment().clone().startOf('month').format('MM/DD/YYYY'),
            endDateFormatted: moment().clone().endOf('month').format('MM/DD/YYYY')
        },

        dashboardCoverageRequestBySalesPerson: {
            labels: [],
            datasets: [{
                label: '',
                backgroundColor: '',
                data: []
            }]
        },

        headers: [
            { text: 'Job Id', value: 'jobIdFormatted', sortable: true, width: '7%' },
            { text: 'Requested On', value: 'dateRequestFormatted', sortable: true, width: '9%' },
            { text: 'Requested By', value: 'requesterName', sortable: true, width: '12%' },
            { text: 'Requested To', value: 'requestedToName', sortable: true, width: '12%' },
            { text: 'Decision', value: 'decisionStatusDescription', sortable: true, width: '8%' },
            { text: 'Decision On', value: 'dateDecisionFormatted', sortable: true, width: '9%' },
            { text: 'Customer', value: 'customerName', sortable: true, width: '12%' },
            { text: 'Request Reason', value: 'requestReason', sortable: false, width: '15%' },
            { text: 'Decision Reason', value: 'decisionReason', sortable: false, width: '16%' },
        ],

        options: { rowsPerPage: 10, page: 1 },
        listCoverageRequestAnalytical: [],

        mnuStartDate: false,
        mnuEndDate: false,

        URL_REPORT_COVERAGE_REQUEST_ANALYTICAL
    }),

    watch: {
        'filter.startDate' () {
            this.filter.startDateFormatted = this.formatDate(this.filter.startDate);
            this.getRegisters();
        },

        'filter.endDate' () {
            this.filter.endDateFormatted = this.formatDate(this.filter.endDate);
            this.getRegisters();
        },
    },

    computed: {
        requesterByRequestedSummary() {
            const groupedRequesters = {};

            if (this.listCoverageRequestAnalytical != null && this.listCoverageRequestAnalytical != undefined) {
                this.listCoverageRequestAnalytical.forEach(item => {
                    const requestedToName = item.requestedToName || '-';
                    const requesterName = item.requesterName || '-';

                    if (!groupedRequesters[requestedToName]) {
                        groupedRequesters[requestedToName] = new Set();
                    }

                    groupedRequesters[requestedToName].add(requesterName);
                });
            }

            return Object.keys(groupedRequesters)
                .sort((a, b) => a.localeCompare(b))
                .map(requestedToName => ({
                    requestedToName,
                    requesterNames: Array.from(groupedRequesters[requestedToName]).join(', ')
                }));
        },

        totals() {
            let totalRequested = 0;
            let totalAccepted = 0;
            let totalDenied = 0;
            let totalPending = 0;

            if (this.listCoverageRequestAnalytical != null && this.listCoverageRequestAnalytical != undefined) {
                this.listCoverageRequestAnalytical.forEach(item => {
                    totalRequested += 1;

                    if (item.decisionStatus == 1) {
                        totalAccepted += 1;
                    }
                    else if (item.decisionStatus == 2) {
                        totalDenied += 1;
                    }
                    else {
                        totalPending += 1;
                    }
                });
            }

            return {
                totalRequested,
                totalAccepted,
                totalDenied,
                totalPending
            };
        }
    },

    methods: {

        formatDate(date) {
            if (!date) return null;

            const [year, month, day] = date.split('-');
            return `${month}/${day}/${year}`;
        },

        async getLists() {
            this.listSellers = await this.$store.dispatch('userModule/ListSalesPerson');
        },

        getFilterRequest() {
            let idRequester = 0;
            let idRequested = 0;
            let decisionStatus = null;

            if (this.filter.requesterSelected != null && this.filter.requesterSelected != undefined) {
                idRequester = this.filter.requesterSelected.id;
            }

            if (this.filter.requestedSelected != null && this.filter.requestedSelected != undefined) {
                idRequested = this.filter.requestedSelected.id;
            }

            if (this.filter.decisionStatusSelected != null && this.filter.decisionStatusSelected != undefined) {
                decisionStatus = this.filter.decisionStatusSelected.id;
            }

            return {
                idRequester,
                idRequested,
                decisionStatus,
                startDate: this.filter.startDate,
                endDate: this.filter.endDate
            };
        },

        async getRegisters() {
            this.showLoading();
            await this.getAnalytical();
            await this.setGraphBySalesPerson();
            this.hideLoading();
        },

        buildRequesterNamesByRequestedToMap() {
            const requesterNamesByRequestedToMap = {};

            if (this.listCoverageRequestAnalytical != null && this.listCoverageRequestAnalytical != undefined) {
                this.listCoverageRequestAnalytical.forEach(item => {
                    const requestedToName = item.requestedToName || '-';
                    const requesterName = item.requesterName || '-';

                    if (!requesterNamesByRequestedToMap[requestedToName]) {
                        requesterNamesByRequestedToMap[requestedToName] = new Set();
                    }

                    requesterNamesByRequestedToMap[requestedToName].add(requesterName);
                });
            }

            return Object.keys(requesterNamesByRequestedToMap).reduce((resultMap, requestedToName) => {
                resultMap[requestedToName] = Array.from(requesterNamesByRequestedToMap[requestedToName]).join(', ');
                return resultMap;
            }, {});
        },

        async setGraphBySalesPerson() {
            const labels = [];
            const totalRequested = [];
            const totalAccepted = [];
            const totalDenied = [];
            const totalPending = [];

            const chartByUser = {};

            if (this.listCoverageRequestAnalytical != null && this.listCoverageRequestAnalytical.length > 0) {
                this.listCoverageRequestAnalytical.forEach(item => {
                    const requesterName = item.requesterName || '-';
                    const requestedToName = item.requestedToName || '-';

                    if (!chartByUser[requesterName]) {
                        chartByUser[requesterName] = {
                            totalRequested: 0,
                            totalAccepted: 0,
                            totalDenied: 0,
                            totalPending: 0
                        };
                    }

                    if (!chartByUser[requestedToName]) {
                        chartByUser[requestedToName] = {
                            totalRequested: 0,
                            totalAccepted: 0,
                            totalDenied: 0,
                            totalPending: 0
                        };
                    }

                    // Only requester gets credit for requesting
                    chartByUser[requesterName].totalRequested += 1;

                    // Only requested-to person gets credit for acceptance/denial
                    if (item.decisionStatus == 1) {
                        chartByUser[requestedToName].totalAccepted += 1;
                    }
                    else if (item.decisionStatus == 2) {
                        chartByUser[requestedToName].totalDenied += 1;
                    }
                    else {
                        chartByUser[requestedToName].totalPending += 1;
                    }
                });

                Object.keys(chartByUser)
                    .sort((a, b) => a.localeCompare(b))
                    .forEach(userName => {
                        labels.push(userName);
                        totalRequested.push(chartByUser[userName].totalRequested);
                        totalAccepted.push(chartByUser[userName].totalAccepted);
                        totalDenied.push(chartByUser[userName].totalDenied);
                        totalPending.push(chartByUser[userName].totalPending);
                    });
            }

            this.dashboardCoverageRequestBySalesPerson.datasets = [
                {
                    label: 'Requested',
                    backgroundColor: '#0277BD',
                    borderColor: '#0277BD',
                    data: totalRequested
                },
                {
                    label: 'Accepted',
                    backgroundColor: '#2E7D32',
                    borderColor: '#2E7D32',
                    data: totalAccepted
                },
                {
                    label: 'Denied',
                    backgroundColor: '#C62828',
                    borderColor: '#C62828',
                    data: totalDenied
                },
                {
                    label: 'Pending',
                    backgroundColor: '#F9A825',
                    borderColor: '#F9A825',
                    data: totalPending
                }
            ];

            if (this.$refs.chartCoverageRequests) {
                this.$refs.chartCoverageRequests.$refs.chart._data._chart.config._config.data.labels = labels;
                this.$refs.chartCoverageRequests.$refs.chart._data._chart.config._config.data.datasets = this.dashboardCoverageRequestBySalesPerson.datasets;
                this.$refs.chartCoverageRequests.$refs.chart._data._chart.update('none');
            }
        },

        async getAnalytical() {
            this.listCoverageRequestAnalytical = await this.$store.dispatch(
                'reportModule/CoverageRequestAnalytical',
                this.getFilterRequest()
            );
        },

        goToServiceDetails(id) {
            this.$router.push({ name: 'serviceDetails', params: { id: id } });
        },
    },

    async created() {
        this.showLoading();
        await this.getLists();
        await this.getRegisters();
        this.hideLoading();
    }
});
</script>
